import { Radio as DSRadio } from '@designsystem/stories/02-atoms/Radio';

export interface RadioProps {
  /**
   * The ID of the radio.
   */
  id?: string;
  /**
   * The name of the radio.
   */
  name?: string;
  /**
   * The value of the radio.
   */
  value?: string;
  /**
   * Whether the radio button is selected
   */
  selected?: boolean;
  /**
   * The label of the radio.
   */
  label?: string;
  /**
   * Whether the radio is disabled.
   */
  isDisabled?: boolean;
  /**
   * The onChange handler.
   */
  onChange?: (selected: boolean) => void;
  /**
   * The onClick handler.
   */
  onClick?: () => void;
  error?: boolean;
}

const Radio = ({ isDisabled, ...props }: RadioProps) => {
  return (
    <li>
      <DSRadio disabled={isDisabled} {...props} />
    </li>
  );
};

export default Radio;
